import React from 'react';
import styles from './panel.scss';

import { Icon } from '../icons';

const Panel = ({ title, footer, children, onCloseClick }) => {
  return (
    <div className="panel">
      <div className="inner-panel">
        <div className="header">
          <a href="#" onClick={onCloseClick}>
            <Icon type={'cross'} className="panel-close"/>
          </a>
          <h2>{title}</h2>
        </div>
        <div className="content">
          {children}
        </div>
        <div className="footer">
          {footer}
        </div>
      </div>
    </div>
  )
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/layout/Panel.js